// Custom TailwindCSS modals for confirm dialogs
// Works with Turbo - intercepts confirm events

const createConfirmModal = (element, message) => {
  var id = 'confirm-modal-' + String(Math.random()).slice(2, -1)

  var content = `
    <div id="${id}" class="animated fadeIn fixed top-0 left-0 w-full h-full table" style="background-color: rgba(0, 0, 0, 0.8); z-index: 9999;">
      <div class="table-cell align-middle">
        <div class="bg-white mx-auto rounded shadow p-8 max-w-sm">
          <h4>${message}</h4>
          <div class="flex justify-end items-center flex-wrap mt-6">
            <button data-behavior="cancel" class="btn btn-white primary mr-2">Cancel</button>
            <button data-behavior="commit" class="btn btn-danger focus:outline-none">Confirm</button>
          </div>
        </div>
      </div>
    </div>
  `

  document.body.insertAdjacentHTML('beforeend', content)
  var modal = document.getElementById(id)

  return new Promise((resolve, reject) => {
    modal.addEventListener("keyup", (event) => {
      if (event.key === "Escape") {
        event.preventDefault()
        modal.remove()
        resolve(false)
      }
    })

    modal.querySelector("[data-behavior='cancel']").addEventListener("click", (event) => {
      event.preventDefault()
      modal.remove()
      resolve(false)
    })

    modal.querySelector("[data-behavior='commit']").addEventListener("click", (event) => {
      event.preventDefault()
      modal.remove()
      resolve(true)
    })

    modal.querySelector("[data-behavior='commit']").focus()
  })
}

// Turbo confirm method (Rails 8+ API)
Turbo.config.forms.confirm = (message, element) => {
  return createConfirmModal(element, message)
}
